var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardOutlineRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12321",
    "data-name": "Group 12321",
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18139",
    "data-name": "Rectangle 18139",
    width: 28,
    height: 28,
    transform: "translate(10 10)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12320",
    "data-name": "Group 12320",
    transform: "translate(-31.905 -230.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12726",
    "data-name": "Path 12726",
    d: "M65.257,261.818h-18.7a.485.485,0,0,1-.362-.8l1.657-1.979a1.9,1.9,0,0,0,.44-1.215v-7.158a7.683,7.683,0,0,1,7.618-7.747h0a7.683,7.683,0,0,1,7.617,7.747v7.158a1.9,1.9,0,0,0,.44,1.215l1.658,1.979A.485.485,0,0,1,65.257,261.818Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#EF5658",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12727",
    "data-name": "Path 12727",
    d: "M55.362,264.653a3,3,0,0,0,3-3h-6A3,3,0,0,0,55.362,264.653Z",
    transform: "translate(0.544 2.753)",
    fill: "#EF5658"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardOutlineRed);
export default __webpack_public_path__ + "static/media/standard_outline_red.6f517c5212f7f8a6fc4eda35a3840126.svg";
export { ForwardRef as ReactComponent };